import {
  DEZIIGN_SORTING_IDX,
  HSE_SORTING_IDX,
  LMS_OFFLINE_SHOWCASE_IDX,
  LMS_SORTING_IDX,
  SUPERPUPER_SORTING_IDX
} from "../const/sorting_tsx";

interface convertSortingParams {
  isHSEDesign: boolean;
  isOnlines: boolean;
  isAgeytomesh: boolean;
  isDeziiign: boolean;
  isSuperPuper: boolean;
  isPro: boolean;
  isTeam?: boolean;
  isLMSRequest?: boolean;
  isLMSOfline?: boolean;
}

export const convertSorting = (sorting: any, params: convertSortingParams) => {
  if (params.isLMSRequest) {
    //@ts-ignore
    return LMS_SORTING_IDX[sorting];
  }
  if (params.isLMSOfline) {
    //@ts-ignore
    return LMS_OFFLINE_SHOWCASE_IDX[sorting]
  }
  if (params.isHSEDesign || params.isOnlines || params.isTeam) {
    //@ts-ignore
    return HSE_SORTING_IDX[sorting];
  }
  if (params.isSuperPuper) {
    //@ts-ignore
    return SUPERPUPER_SORTING_IDX[sorting];
  }
  if (params.isAgeytomesh) {
    return sorting;
  }
  if (params.isDeziiign && !params.isPro) {
    //@ts-ignore
    return DEZIIGN_SORTING_IDX[sorting]
  }
  //@ts-ignore
  return DEZIIGN_SORTING_IDX[sorting]
}import {
  DEZIIGN_SORTING_IDX,
  HSE_SORTING_IDX,
  LMS_OFFLINE_SHOWCASE_IDX,
  LMS_SORTING_IDX,
  SUPERPUPER_SORTING_IDX
} from "../const/sorting_tsx";

interface convertSortingParams {
  isHSEDesign: boolean;
  isOnlines: boolean;
  isAgeytomesh: boolean;
  isDeziiign: boolean;
  isSuperPuper: boolean;
  isPro: boolean;
  isTeam?: boolean;
  isLMSRequest?: boolean;
  isLMSOfline?: boolean;
}

export const convertSorting = (sorting: any, params: convertSortingParams) => {
  if (params.isLMSRequest) {
    //@ts-ignore
    return LMS_SORTING_IDX[sorting];
  }
  if (params.isLMSOfline) {
    //@ts-ignore
    return LMS_OFFLINE_SHOWCASE_IDX[sorting]
  }
  if (params.isHSEDesign || params.isOnlines || params.isTeam) {
    //@ts-ignore
    return HSE_SORTING_IDX[sorting];
  }
  if (params.isSuperPuper) {
    //@ts-ignore
    return SUPERPUPER_SORTING_IDX[sorting];
  }
  if (params.isAgeytomesh) {
    return sorting;
  }
  if (params.isDeziiign && !params.isPro) {
    //@ts-ignore
    return DEZIIGN_SORTING_IDX[sorting]
  }
  //@ts-ignore
  return DEZIIGN_SORTING_IDX[sorting]
}